import React, { useContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider, AuthContext } from "./hooks/useLogin";
import { ToastContainer } from "react-toastify"; // ✅ Add ToastContainer
import "react-toastify/dist/ReactToastify.css"; // ✅ Import Toastify CSS

// User pages
import HomePage from "./Pages/HomePage";
import Marketplace from "./Pages/Marketplace";
import ProductDetails from "./Pages/ProductDetails";
import Inbox from "./Pages/Inbox";
import Cart from "./Pages/Cart";
import OrderSummary from "./Pages/OrderSummary";
import YourAddresses from "./Pages/YourAddresses";
import NewAddress from "./Pages/NewAddress";
import EditAddress from "./Pages/EditAddress";
import Order from "./Pages/Order";
import Profile from "./Components/profile";

// Admin pages
import Dashboard from "./Pages/Admin/Dashboard";
import Sidebar from "./Components/Admin/Sidebar"; // ✅ Fixed import path consistency
import Products from "./Pages/Admin/Products";
import Orders from "./Pages/Admin/Orders";
import Sold from "./Pages/Admin/Sold";
import Messages from "./Pages/Admin/Messages";
import AddProducts from "./Pages/AddProducts";
import Add from "./Pages/Admin/Add";
import Userlist from "./Pages/Admin/Userlist";
import AdminHomepage from "./Pages/Admin/AdminHomepage";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer position="top-right" autoClose={5001} hideProgressBar={false} /> {/* ✅ Add ToastContainer */}
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
};

const AppRoutes = () => {
  const { user } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/products/:id" element={<ProductDetails />} />
      <Route path="/inbox" element={<Inbox />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/ordersummary" element={<OrderSummary />} />
      <Route path="/youraddresses" element={<YourAddresses />} />
      <Route path="/newaddress" element={<NewAddress />} />
      <Route path="/editaddress" element={<EditAddress />} />
      <Route path="/order" element={<Order userId={user?.id} />} />
      <Route path="/profile" element={<Profile />} />
      
      {/* Admin Routes */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/sidebar" element={<Sidebar />} />
      <Route path="/products" element={<Products />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/sold" element={<Sold />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/add-product" element={<AddProducts />} />
      <Route path="/add" element={<Add />} />
      <Route path="/userlist" element={<Userlist />} />
      <Route path="/adminhomepage" element={<AdminHomepage />} />
    </Routes>
  );
};

export default App;